import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import Button from './Button.js';
import Modal from './Modal.js';
const ConfirmModal = (props) => {
    const lang = useSelector((s) => s.lang);
    return (React.createElement(Modal, { maxWidth: "480px", header: props.header ?? lang.misc.areYouSure, onToggle: props.onCancel, footer: React.createElement(Actions, null,
            React.createElement(Button, { theme: "secondary", onClick: props.onCancel }, lang.misc.cancel),
            React.createElement(Button, { theme: "dangerous", loading: props.loading, onClick: props.onConfirm }, props.confirmLabel)) },
        React.createElement(Message, null, props.message ?? lang.misc.cannotBeUndone)));
};
export default ConfirmModal;
const Actions = styled.div `
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;
const Message = styled.p `
  margin: 0;
`;
//# sourceMappingURL=ConfirmModal.js.map